import update from 'immutability-helper'
import clsx from 'clsx'
import React, {useContext} from 'react'
import Box from '@mui/material/Box'
import useStyles from './matching/styles'
import Choice from './matching/choice'
import AddChoice from './matching/add-choice'

import {TeacherContext} from 'teacher/context'
import Editor from 'components/quiz/components/editable-html'
import {uuid} from 'helpers/utils'

export default function MatchingQuestion (props) {

  const {index, questionPath, updateProperties} = props
  const context = useContext(TeacherContext)
  const classes = useStyles()

  const {at, translate} = context
  const [question] = at(questionPath)

  const choicesCount = question.answer.choices.length
  const choiceValue = choicesCount > 0 ? (question.value / choicesCount) : 0

  const premiseText = question.premise.html || ''

  function handlePremiseChanged (html, textpremise) {
    const premise = {html}
    updateProperties({id: question.id, premise, textpremise}, {premise: {$set: premise}, textpremise: {$set: textpremise}})
  }

  function handleChoiceMove (drag, hover) {
    const choice = question.answer.choices[drag]
    updateProperties(false, {answer: {choices: {$splice: [[drag, 1], [hover, 0, choice]]}}})
  }

  function handleChoiceDrop () {
    const [question] = at(questionPath)
    const {answer} = question
    updateProperties({id: question.id, answer})
  }

  function handleAddChoice () {
    const [question] = at(questionPath)
    const command = question.answer.choices ? '$push' : '$set'
    const updateCommand = {answer: {choices: {[command]: [['', '', uuid()]]}}}
    const {answer} = update(question, updateCommand)
    updateProperties({id: question.id, answer}, updateCommand)
  }

  function handleChoiceTextChange (id, side, html) {
    const [question] = at(questionPath)
    const index = question.answer.choices.findIndex(([a,b,c]) => c == id)
    const updateText = {answer: {choices: {[index]: {[side]: {$set: html}}}}}
    const {answer} = update(question, updateText)
    updateProperties({id: question.id, answer}, updateText)
  }

  function handleDeleteChoice (id) {
    const [question] = at(questionPath)
    const removeChoice = {answer: {choices: {$apply: choices => choices.filter(([a,b,c]) => c != id)}}}
    const {answer} = update(question, removeChoice)
    updateProperties({id: question.id, answer}, removeChoice)
  }

  return (
    <Box className={clsx(classes.root, "question", "matching")}>
      <Box className={clsx(classes.premise, "premise")}>
        <Box className="label">{translate('instructions')}:</Box>
        <Editor
          context={context}
          html={premiseText}
          onChange={handlePremiseChanged}
        />
      </Box>
      <Box className={clsx(classes.answer, "answer")}>
        <Box className="choices">
          {question.answer.choices && question.answer.choices.map((choice, index, {length}) =>
            <Choice
              key={choice[2]}
              onChoiceMove={handleChoiceMove}
              onChoiceDropped={handleChoiceDrop}
              onChoiceTextChange={handleChoiceTextChange}
              onDeleteChoice={handleDeleteChoice}
              questionCount={length}
              {...{index, choice, context, question, choiceValue}}
            />
          )}
        </Box>
        <AddChoice
          context={context}
          question={question}
          index={index}
          onAddChoice={handleAddChoice}
        />
     </Box>
    </Box>
  )
}
